__turbopack_context__.v({
  "badgeCorner": "O_2iRG_badgeCorner",
  "bg": "O_2iRG_bg",
  "buyButton": "O_2iRG_buyButton",
  "card": "O_2iRG_card",
  "city": "O_2iRG_city",
  "controls": "O_2iRG_controls",
  "dateText": "O_2iRG_dateText",
  "eventTitle": "O_2iRG_eventTitle",
  "iconBtn": "O_2iRG_iconBtn",
  "info": "O_2iRG_info",
  "meta": "O_2iRG_meta",
  "overlay": "O_2iRG_overlay",
  "player": "O_2iRG_player",
  "previewImg": "O_2iRG_previewImg",
  "selectOverlay": "O_2iRG_selectOverlay",
  "toggleOverlay": "O_2iRG_toggleOverlay",
});
